import { getRequest } from './amplify/helpers';

export const getAccountFeatures = async (appKey: string) => {
  if (!appKey) {
    return [];
  }

  try {
    return await getRequest({
      apiName: 'resolveAll',
      path: '/features',
      options: {
        queryParams: {
          appKey,
        },
      },
    });
  } catch (e) {
    console.error('Error in getFeatures:', e);
  }
};
